import { html, LitElement } from "lit"
import { customElement, property } from "lit/decorators.js"
import { ICON_BASE } from "../../styles/base"

/**
 * External link icon component
 */
@customElement("external-link-icon")
export class ExternalLinkIcon extends LitElement {
  static override styles = [ICON_BASE]

  @property({ type: String })
  color = "currentColor"

  @property({ type: String })
  size = "16px"

  override render() {
    return html`
      <svg
        width=${this.size}
        height=${this.size}
        viewBox="0 0 16 16"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
      >
        <title>External link</title>
        <g id="External-link" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <path
            d="M15.085556,0.000370762406 C15.0524534,0.00141697617 15.0194351,0.00431337214 14.9866559,0.00904638777 L10.6610695,0.00904638777 C10.3406923,0.00451536035 10.0426935,0.172842877 9.88118266,0.44957304 C9.71967181,0.726303203 9.71967181,1.0685622 9.88118266,1.34529236 C10.0426935,1.62202252 10.3406923,1.79035004 10.6610695,1.78581901 L12.9583327,1.78581901 L4.70276137,10.0415655 C4.47068619,10.2643881 4.37720105,10.5952667 4.45835987,10.906593 C4.53951869,11.2179193 4.78263955,11.4610453 5.09395927,11.5422057 C5.40527898,11.6233662 5.73615053,11.529879 5.95896837,11.2977988 L14.2145393,3.04205278 L14.2145393,5.33936426 C14.2100084,5.65974827 14.3783323,5.95775341 14.6550566,6.11926769 C14.9317809,6.28078197 15.2740326,6.28078197 15.5507569,6.11926769 C15.8274812,5.95775341 15.9958051,5.65974827 15.9912742,5.33936426 L15.9912742,1.0102161 C16.0270842,0.751330008 15.9470966,0.489808079 15.7725984,0.295248373 C15.5981001,0.100688668 15.3467928,-0.00717209219 15.085556,0.000370762406 Z M1.77739509,0.0089571655 C0.806353686,0.0089571655 0.00066020321,0.814756982 0.00066020321,1.78581901 L0.00066020321,14.2232274 C0.00066020321,15.1942896 0.806353686,16 1.77739509,16 L14.2145393,16 C15.1855809,16 15.9913634,15.1942896 15.9913634,14.2232274 L15.9913634,8.89290951 C15.9958051,8.57252549 15.8274812,8.27452035 15.5507569,8.11300607 C15.2740326,7.95149179 14.9317809,7.95149179 14.6550566,8.11300607 C14.3783323,8.27452035 14.2100084,8.57252549 14.2145393,8.89290951 L14.2145393,14.2232274 L1.77739509,14.2232274 L1.77739509,1.78581901 L7.10759976,1.78581901 C7.42797696,1.79035004 7.72597578,1.62202252 7.88748663,1.34529236 C8.04899748,1.0685622 8.04899748,0.726303203 7.88748663,0.44957304 C7.72597578,0.172842877 7.42797696,0.00451536035 7.10759976,0.0089571655 L1.77739509,0.0089571655 Z"
            id="Shape"
            fill=${this.color}
            fill-rule="nonzero"
          ></path>
        </g>
      </svg>
    `
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "external-link-icon": ExternalLinkIcon
  }
}
